import React from 'react';

const booleanToText = value => {
  if (value === true || value === 'true') return 'Enabled';
  if (value === false || value === 'false') return 'Disabled';
  return '-';
};

const formatValue = value => {
  if (value === '' || value === null || value === undefined) return '-';
  if (typeof value === 'boolean') return booleanToText(value);
  return value;
};

const KeyValueRow = ({
  label,
  value,
  requestedValue,
  labelWidth = '45%',
  valueWidth = '55%',
}) => {
  const formattedValue = formatValue(value);
  const formattedRequestedValue = formatValue(requestedValue);

  const hasRequestedChange =
    requestedValue !== undefined && requestedValue !== value;

  return (
    <div className="d-flex mb-2 fs-10">
      <div className="fw-semibold text-700" style={{ width: labelWidth }}>
        {label}
      </div>

      <div className="text-black" style={{ width: valueWidth }}>
        {formattedValue}
        {hasRequestedChange && (
          <div style={{ color: '#F68F57' }}>→ {formattedRequestedValue}</div>
        )}
      </div>
    </div>
  );
};

export default KeyValueRow;
